<template>
  <div style="background-color: #f2f2f2;height: 100%;">

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
      病患列表
    </div>
    <div style="padding: 20px;">
      <div>
        <el-row>
          <!--          <el-button plain type="primary"  @click.native="toggleModalAdd">添加</el-button>-->
          <!--          <el-button plain type="success" icon="el-icon-upload"  @click="batchDialog=true">批量添加</el-button>-->

          <div style="float:right">
            <el-input placeholder="输入姓名" v-model="name" clearable style="width:120px;margin-right:10px"></el-input>
            <el-input placeholder="输入手机号" v-model="phone" maxlength="11" clearable style="width:150px;margin-right:10px"></el-input>
            <el-select v-model="status" placeholder="请选择状态" style="width:150px;margin-right:10px">
              <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                          placeholder="请选择所属区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                          style="width:200px;margin-right:10px"></elSelectTree>
            <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button></div>

        </el-row>

        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>

          <el-table :data="tableData" :height="th" ref="table" border stripe
                    style="width: 100%;"
                    v-loading="loading" :row-class-name="tableRowClassName">

            <el-table-column prop="userName" fixed="left" label="姓名" width="100"></el-table-column>
            <el-table-column prop="userPhone" label="手机号" width="150"></el-table-column>
            <el-table-column prop="idCard" label="身份证号" width="200"></el-table-column>
            <el-table-column prop="loginName" label="APP登录账号" width="200"></el-table-column>
            <el-table-column prop="createTime" :formatter="getTime" label="注册时间" width="150"></el-table-column>
            <el-table-column prop="balance" label="余额" width="100"></el-table-column>


            <el-table-column prop="userStatus" :formatter="userStatus" label="状态" width="100px"></el-table-column>
            <el-table-column prop="zoneName" label="所在区域" width="300" ></el-table-column>
            <el-table-column prop="homeAddress" label="住址" width="300" ></el-table-column>


          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
            </div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"
                  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import elderly from "@/common/status";

import {getStaffCode} from "@/utils/auth";
import elSelectTree from "@/components/ElSelectTree"

export default {
  name: "Role",
  data() {
    return {

      uploadUrl:this.$shopUrl+'ImportExcel/Import',
      uploadData:{
        staffCode:getStaffCode(),
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
      },
      batchFileList:[],
      ICCardDialog:false,
      icCard:'',
      elderlyCode:'',
      batchDialog:false,
      batchDialogError:false,
      errorData:[],
      showModal:false,
      showModalDevice:false,
      censusRegister:'',
      loading: false,
      showModalAdd: false,
      showModalOldManFile: false,
      datetimerangeValue: '',
      showModalEdit: false,
      showModalSearch: false,
      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,
      name: '',
      idCard: '',
      ctiyDate: [],
      elderlyType: elderly.serviceType,
      elderlyClassValue: [],
      nationValue: [],
      zoneValue: [],
      areaValue: [],
      zoneCode: '',
      elderlyAllType: elderly,
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      phone: '',
      elderlyClassList:'',
      elderlyClass:-1,
      censusRegisterList:['城市','农村'],
      status:1,
      statusList: [
        {
          value: -1, label: '全部状态'
        }, {
          value: 1, label: '正常'
        }, {
          value: 2, label: '禁用'
        }
      ],

      balanceAll:0,

    }
  },
  components: {
    elSelectTree
  },

  created() {
    this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {
    init: function () {
      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 365);
      this.datetimerangeValue = [start, end];

      // this.$axios({
      //   method: 'post',
      //   url: this.$shopUrl + "ElderlyClass/List",
      //   data: {
      //     timeStr: timeStr,
      //     sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
      //     staffCode: getStaffCode(),
      //   }
      // }).then(
      //     (response) => {
      //       if (response.data.error === 0) {
      //         this.elderlyClassValue = response.data.data;
      //
      //         var  elderlyClassValue1=[];
      //         elderlyClassValue1.push({label:'全部分类' ,value:-1 })
      //         for (let i in this.elderlyClassValue){
      //           let j={label:this.elderlyClassValue[i].name ,value:this.elderlyClassValue[i].value }
      //           elderlyClassValue1.push(j)
      //         }
      //         this.elderlyClassValue=elderlyClassValue1
      //       } else if (response.data.error === 1) {
      //         this.$message.error(response.data.message)
      //       }
      //     }
      // ),
      //     this.$axios({
      //       method: 'post',
      //       url: this.$shopUrl + "Zone/ListForStaff",
      //       data: {
      //         timeStr: timeStr,
      //         sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
      //         staffCode: getStaffCode(),
      //       }
      //     }).then(
      //         (response) => {
      //           if (response.data.error == 0) {
      //             var data = JSON.stringify(response.data.data);
      //             data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
      //             this.zoneValue = data;
      //             this.zoneCode=data[0].zoneCode;
      //             this.getList();
      //           } else if (response.data.error == 1) {
      //             this.$message({type: 'info', message: response.data.message});
      //           }
      //         }
      //     )

      this.getList();

    },
    closeBatchDialog(){
      this.$refs.upload.clearFiles();
    },
    uploadSuccess(response){
      // this.$refs.bulkUpload.clearFiles()
      if(response.error === 0){
        this.batchDialog=false
        this.uuid = response.data;
        // this.getList()
      }else if(response.error === 1){
        this.$message.error(response.data.message)
      }

    },
    getZoneValue(val) {
      this.zoneCode = val
    },
    getTime(row,index,column){
      return timefilters(column)
    },
    tableRowClassName({row}) {
      const timeAudit = new Date(row.timeAudit);
      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
      if (timeAudit >= start) {
        return 'success-row';
      }
      return '';
    },

    submitUpload(){
      this.showModal=true
      this.$refs.upload.submit();
      this.crontab();
    },
    crontab() {
      this.timer = setInterval(this.getSuccess, 1000 * 1);
    },
    getSuccess() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ImportExcel/IsSuccess",
        data: {
          uuid: this.uuid
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.showModal=true
          this.isSuccess = response.data.data;
          if (this.isSuccess === "0") {
            this.showModal=true
          }
          if (this.isSuccess === "1") {
            this.$message({type: 'success', message: '导入成功'});
            this.showModal=false
            this.getList();
            this.inCrontab();

          }
          if (this.isSuccess === "2") {
            this.$message({type: 'error', message: '导入失败'});
            // this.getList();
            this.inCrontab();
            this.showModal=false
          }
          if (this.isSuccess !== "1" && this.isSuccess !== "2" && this.isSuccess !== "0") {
            if(this.isSuccess.length>10){
              this.batchDialogError=true
              this.errorData=this.isSuccess.split('<br>')
            }else{
              this.$message.error({type: 'success', message: this.isSuccess});
            }

            this.inCrontab();
            this.showModal=false
          }


        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        } else if (response.data.error === 2) {
          this.$message({type: 'success', message: '导入失败'});
          this.inCrontab();
          this.showModal=false
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    inCrontab() {
      clearInterval(this.timer);
    },
    getTemplate(){
      var that=this
      this.$axios.get(this.$shopUrl+'ImportExcel/GetElderlyTemplate',{
        responseType: 'blob',
        params:{
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            let fileName = '老人导入模板.xlsx';
            that.file(response,fileName);
          }
      )
    },
    file(response, fileName) {
      let blob = new Blob([response.data]);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      }
    },
    handleEdit(row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    handleInfo(row) {
      this.$refs.myOldManFile.init(row);
      this.showModalOldManFile = !this.showModalOldManFile;
    },
    bindCard(row){
      this.ICCardDialog=true;
      if(row.icCard){
        this.icCard=row.icCard
      }else{
        this.icCard=''
      }

      this.elderlyCode=row.elderlyCode
    },
    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },
    closeOldManFile(){
      this.showModalOldManFile = !this.showModalOldManFile;
    },
    toggleModalSearch: function () {
      this.showModalSearch = !this.showModalSearch;
      this.$refs.mySearch.init();
    },
    closeSearch: function () {
      this.showModalSearch = !this.showModalSearch;
    },
    toggleModalEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },
    closeDevice:function (){
      this.showModalDevice = !this.showModalDevice;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    DeviceManage(index, row){
      this.$refs.myPageForDevice.init(row);
      this.showModalDevice = !this.showModalDevice;
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.loading=true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/NursePage",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),

          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          phone: this.phone,
          name:this.name,
          status:this.status,
          zoneCode:this.zoneCode
        }
      }).then((response) => {

        this.loading=false;
        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
          this.balanceAll = response.data.data.balanceAll;

          this.$nextTick(()=>{this.$refs.table.doLayout()});

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        //this.loading=false;
        console.log(error);
      });
    },
    getTotal(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 5) {
          sums[index] = this.balanceAll;
          return;
        }
        // const values = data.map(item => Number(item[column.property]));
        // if (column.property === 'balance') {
        //     sums[index] = values.reduce((prev, curr) => {
        //     const value = Number(curr);
        //     if (!isNaN(value)) {
        //         return this.tableData[3];
        //     } else {
        //         return this.tableData[0];
        //     }
        //     }, 0);
        //     sums[index];
        // } else {
        //     sums[index] = '';
        // }
      });
      return sums;
    },
    bindSubmit(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/BindIcCard",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          icCard:this.icCard,
          elderlyCode:this.elderlyCode
        }
      }).then((response) => {
        this.loading=false;
        if (response.data.error == 0) {
          this.ICCardDialog=false
          this.getList()
          this.$message({type: 'success', message: '绑定成功'});
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    userStatus(row) {
      if (row.userStatus == 1) {
        return "正常";
      }
      if (row.userStatus == 2) {
        return "禁用";
      }
      return "其它";
    },
    elderlyTypes(row) {
      if (row.elderlyType == 0) {
        return "政府购买服务";
      }
      if (row.elderlyType == 1) {
        return "有偿服务";
      }
      if (row.elderlyType == -1) {
        return "";
      }
      return "其它";
    },
    politics(row) {
      return this.allStatus(row.politicsStatus, elderly.politicalOutlook);
    },
    censusRegisters(row) {
      return this.allStatus(row.censusRegister, elderly.natureHRegistrater);
    },
    educations(row) {
      return this.allStatus(row.education, elderly.education);
    },
    allStatus(row, status) {
      for (var i in status) {
        if (status[i].value == row) {
          return status[i].label
        }
      }
      return "其它";
    },
  }
}
</script>
<style>
.el-table .success-row {
  background: #f0f9eb;
}
</style>
<style   lang="scss" scoped>
.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;

}

.label{
  padding: 5px 0px;
}
</style>
